import { styled } from '@material-ui/styles'
import { FC, useRef, useState } from 'react'
import MyAccordion from '../../../../control/accordion/accordion'
import MyButton from '../../../../control/button/button'
import useTranslate from '../../../../i18n/useTranslate'

import EditOutlinedIcon from '@material-ui/icons/EditOutlined'

import IconButton from '@material-ui/core/IconButton'
import Tooltip from '../../../../control/tooltip/tooltip'
import { useForm } from 'react-final-form'
import Dialog from '../../../../control/dialog/dialog'
import { validateModeAccordionError } from '../../../../utilities/validate'

const ConfirmBtn = styled(MyButton)({
    /** Confirm Style */
})

const CancelBtn = styled(MyButton)({
    /** Cancel Style */
})

const ModeAccordion: FC<{
    title: string
    renderViewComponent: () => JSX.Element
    renderEditComponent: () => JSX.Element
    onConfirm?: () => void
    onCancel?: () => void
    onClickEdit?: () => void
    additionIcon?: () => JSX.Element
    fieldNames?: string[]
    isViewMode?: boolean
    isAddOtherLanguage?: boolean
    noPadding?: boolean
}> = ({
    renderViewComponent,
    renderEditComponent,
    title,
    onConfirm: handleConfirm,
    onCancel: handleCancel,
    additionIcon,
    onClickEdit: handleEdit,
    fieldNames = [],
    isViewMode,
    isAddOtherLanguage = true,
    noPadding = false,
}) => {
    const translate = useTranslate()
    const [isEditting, setIsEditting] = useState(false)
    const form = useForm()
    const formStateRef = useRef<{ [key: string]: any }>({})
    const confirmRef = useRef<Record<string, Function>>()
    const cancelRef = useRef<Record<string, Function>>()

    const onClickEdit = (evt: any) => {
        onClickParent(evt)
        formStateRef.current = form.getState().values
        handleEdit && handleEdit()
        setIsEditting(true)
    }

    const onClickParent = (evt: any) => {
        evt.stopPropagation()
    }

    const onConfirm = (evt: any) => {
        onClickParent(evt)
        const isError = validateModeAccordionError(fieldNames, form.getState())
        if (!isError) {
            confirmRef?.current?.openDialog()
        } else {
            form.submit()
        }
    }

    const onSubmitConfirm = () => {
        if (handleConfirm) {
            Promise.all([handleConfirm()]).then(() => setIsEditting(false))
        } else {
            setIsEditting(false)
        }
        confirmRef?.current?.closeDialog()
    }

    const onCancel = (evt: any) => {
        let isDirty = false
        onClickParent(evt)
        fieldNames.forEach((key) => {
            if (form.getFieldState(key)?.dirty) {
                isDirty = true
            }
        })
        if (isDirty) {
            cancelRef?.current?.openDialog()
        } else {
            onSubmitCancel()
        }
    }

    const onSubmitCancel = () => {
        fieldNames.forEach((key) => {
            form.change(key, formStateRef.current[key])
        })
        if (handleCancel) {
            Promise.all([handleCancel()]).then(() => setIsEditting(false))
        } else {
            setIsEditting(false)
        }
        cancelRef?.current?.closeDialog()
    }

    const bindConfirmRef = (func: Record<string, Function>) => {
        confirmRef.current = { ...func }
    }

    const bindCancelRef = (func: Record<string, Function>) => {
        cancelRef.current = { ...func }
    }

    return (
        <>
            <MyAccordion
                noPadding={noPadding}
                title={title}
                titleIcon={
                    isViewMode
                        ? () => (
                              <>
                                  {!isEditting && isAddOtherLanguage ? (
                                      <Tooltip title={translate.get('BUTTON.EDIT')}>
                                          <IconButton size="small" onClick={onClickEdit}>
                                              <EditOutlinedIcon color="primary" />
                                          </IconButton>
                                      </Tooltip>
                                  ) : (
                                      <>
                                          &nbsp;
                                          <CancelBtn color="secondary" onClick={onCancel}>
                                              {translate.get('BUTTON.CANCEL')}
                                          </CancelBtn>
                                          &nbsp;
                                          <ConfirmBtn color="primary" onClick={onConfirm}>
                                              {translate.get('BUTTON.CONFIRM')}
                                          </ConfirmBtn>
                                      </>
                                  )}
                                  &nbsp;
                                  {additionIcon && additionIcon()}
                              </>
                          )
                        : () => <></>
                }
            >
                {isEditting || !isAddOtherLanguage ? renderEditComponent() : renderViewComponent()}
            </MyAccordion>
            <Dialog
                onRef={bindConfirmRef}
                type="alert-confirm"
                title={translate.get('ALERT.TITLE.NOTIFICATION')}
                content={translate.get('ALERT.CONTENT.NEED_TO_SAVE')}
                onClickConfirm={onSubmitConfirm}
            />
            <Dialog
                onRef={bindCancelRef}
                type="alert-confirm"
                title={translate.get('ALERT.TITLE.NOTIFICATION')}
                content={translate.get('ALERT.CONTENT.NEED_TO_CANCEL')}
                onClickConfirm={onSubmitCancel}
            />
        </>
    )
}

export default ModeAccordion
